<template>
    <div :style="!$kmsTheme ? null : $kmsTheme.styles.footer" class="footer">
        <p class="footerText">{{footer}}</p>
    </div>
</template>

<script>
    import Vue from 'vue';
    

    export default {
        data() {
            return {
                
            }
        },
        props: {
            footer: {

            }
        }
    }
</script>
<style>
    
    .footer{
        font-size:2rem;
    }
    
</style>
